import { useQuery } from '@tanstack/react-query';

import { apiGetContactPolicyTypes } from 'api/acturis/client-center';

export const CLIENT_CENTER_CUSTOMER_POLICY_TYPES_KEY =
  'client-center-customer-policy-types';

const EMPTY_POLICY_TYPES: string[] = [];

export const useClientCenterCustomerPolicyTypes = (customerId: string) => {
  const { data, isLoading, error } = useQuery<{ policy_types: string[] }>({
    queryKey: [CLIENT_CENTER_CUSTOMER_POLICY_TYPES_KEY, customerId],
    queryFn: () => apiGetContactPolicyTypes(customerId),
    enabled: Boolean(customerId),
    staleTime: 30 * 1000,
    retry: false,
  });

  return {
    policyTypes: data?.policy_types ?? EMPTY_POLICY_TYPES,
    isLoading,
    error,
  };
};
